<strong>{{tooltipStr}}</strong>